export function getFileType(encoded) {
  var result = 'png'; //default file extension
  if (typeof encoded !== 'string') {
    return result;
  }
  var mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
  if (mime && mime.length) {
    result = mime[1];
    result = result.replace('image/', '');
  }
  return result;
}

export function getBase64String(encoded) {
  var result = encoded;
  if (typeof encoded !== 'string') {
    return result;
  }
  if (encoded.indexOf(',') >= 0) result = encoded.substring(encoded.indexOf(',') + 1, encoded.length);
  return result;
}
